import React from 'react'
import { SvgIcon, SxProps } from '@mui/material'

interface Props {
  sx?: SxProps
  [prop: string]: any
}

export const ReceivedIcon = ({ sx, ...props }: Props) => (
  <SvgIcon
    viewBox="0 0 20 14"
    sx={{ width: '20px', height: '14px', color: 'gray', ...sx }}
    {...props}
  >
    <path
      d="M9.49984 8.50098L8.49984 9.58431L10.6665 11.6676V11.751L19.0832 3.33431L17.9998 2.25098L10.6665 9.58431L9.49984 8.50098ZM5.08317 11.6676V11.751L13.4998 3.33431L12.4165 2.25098L5.08317 9.58431L1.99984 6.50098L0.916504 7.58431L5.08317 11.6676Z"
      fill="#818181"
    />
  </SvgIcon>
)

ReceivedIcon.defaultProps = {
  sx: null,
}
